module.exports = __webpack_public_path__ + "img/bd_other05.96cf677c.png";